import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import classes from "./Footer.module.css";
import logo from "../../Assets/logo.png";
import { MyContext } from "../../Context/MyContext";

function Footer() {
  const { appointmentRef } = useContext(MyContext);
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <Container>
        <div className={classes.cta}>
          <h2>Let’s talk about the work.</h2>
          <p>
            Software, marketing, AI automations, GoHighLevel, design, and
            virtual assistance — scoped to what will move your business.
          </p>
          <button
            onClick={() => {
              window.location.hash = "#book-appointment";
              appointmentRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            className="buttonHome"
          >
            Book a Call
          </button>
        </div>
        <Row className={classes.meta}>
          <Col>
            <div className={classes.brand}>
              <img src={logo} alt="" />
              <span>DigitaliNation</span>
            </div>
          </Col>
          <Col>
            <div className={classes.copy}>Copyright © 2024 - {year}</div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
